import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/component/common/ExitIntentPrompt.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/homes/home-one/EventArea.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/homes/home-one/FaqArea.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/component/homes/home-one/GovernanceArea.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/component/homes/home-one/Hero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/homes/home-one/InvestArea.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/homes/home-one/RoadmapArea.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/homes/home-one/Team.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/component/homes/home-one/VisionArea.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/layouts/footers/FooterOne.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/layouts/headers/HeaderOne.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/layouts/Wrapper.tsx");
